<template>
  <div >
    <headertop></headertop>
    <div class="main">
      <h1>任务列表</h1>
      <el-tabs tab-position="left" style="margin-top: 10px;">
        <!-- 学习任务-->
        <el-tab-pane   stripe style="margin-left: 25px;">
          <span slot="label">
            <span class="span-box">
              <span>学习任务</span>
                <span class="btn-bell-badge" style="background-color: #409eff;border-radius:5px;">
                  <span  style="padding: 0.625rem;color: white; width: 1.25rem;">{{study.count}}</span>
                </span>
            </span>
          </span>
          <div class="con">
            <!-- 搜索框 -->
            <!-- <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model.trim="search"
             @keyup.enter.native="searchAllCompany('study')"   style="width: 90%;margin: 0 5%;" ></el-input> -->
             <el-tabs type="border-card" :stretch='true' @tab-click="study_handleClick" v-model="study.end" >
               <el-tab-pane v-for="(item,study_index) in type_list" :label="item.label" :name="item.name" :key="study_index">
                 <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model.trim="search"
                  @keyup.enter.native="searchAllCompany('study')"   style="width: 90%;margin: 0 5%;" ></el-input>
              <el-table :data="study.list" stripe style="width: 90%;margin: 0 5%;" fit>
                <el-table-column   prop="name" sortable label="任务主题" >
                </el-table-column>
                <el-table-column label="任务级别"  >
                  <template slot-scope="scope">
                    <span v-if="study.list[scope.$index].role_type==0">企业级</span>
                    <span v-if="study.list[scope.$index].role_type==1">部门级</span>
                    <span v-if="study.list[scope.$index].role_type==2">个人级</span>
                  </template>

                </el-table-column>
                <el-table-column prop="start_time"  sortable label="开始日期">
                </el-table-column>
                <el-table-column prop="end_time"  sortable label="结束日期">
                </el-table-column>
                <el-table-column label="任务状态" >
                  <template slot-scope="scope">
                    <span
                      v-if="new Date(study.list[scope.$index].start_time).getTime()>new Date(study.today).getTime()">
                      <img src="../../../assets/red.jpg" class="imgs" />
                      未开启</span>
                    <span v-else>
                      <span v-if="study.list[scope.$index].end==0">
                        <span v-if="study.list[scope.$index].start==0">
                          <img src="../../../assets/red.jpg" class="imgs" />
                          未开始</span>
                        <span v-else>
                          <span
                            v-if="new Date(study.list[scope.$index].end_time).getTime()<new Date(study.today).getTime()">
                              <img src="../../../assets/red.jpg" class="imgs" />
                              已逾期</span>
                          <span v-else>
                             <img src="../../../assets/red.jpg" class="imgs" />
                            进行中</span>
                        </span>
                      </span>
                      <span v-else>
                        <span
                          v-if="new Date(study.list[scope.$index].end).getTime()<=new Date(study.list[scope.$index].end_time+' 23:59:59').getTime()">
                            <img src="../../../assets/green.jpg" class="imgs" />
                            已完成</span>
                        <span v-else>
                           <img src="../../../assets/green.jpg" class="imgs" />
                          逾期完成</span>
                      </span>
                    </span>
                  </template>
                </el-table-column>

                <el-table-column label="操作" >
                  <template slot-scope="scope">
                    <span v-if="new Date(study.list[scope.$index].start_time).getTime()<=new Date(study.today).getTime()">
                      <span v-if="study.list[scope.$index].end==0">
                      <el-button size="mini"  @click="study_train(study.list[scope.$index].num,'train')">进行任务</el-button>
                      </span>
                      <span v-else>
                        <span>
                          <el-button @click="study_train(scope.row.num,'watch')" size="mini">任务回看</el-button>
                        </span>
                        <span>
                          <el-button @click="study_watch(scope.row,'qianming')"
                            v-if="scope.row.idcard_status=='1' && scope.row.idcard=='0' && scope.row.end!='0'"  size="mini">
                            电子签名
                          </el-button>
                        </span>
                        <span >
                          <el-button @click="study_watch(scope.row,'queren')"
                          v-if="scope.row.confirm_status=='1' && scope.row.confirm!='1' && scope.row.end!='0'"  size="mini">
                          任务确认
                        </el-button>
                        </span>
                      </span>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block center">
                <el-pagination @size-change="(val) => handleSizeChange('study', val)"
                  @current-change="(val) => handleCurrentChange('study', val)" :current-page="study.currentPage"
                  :page-sizes="[10, 20, 30, 40]" :page-size="study.pageSize"
                  layout="total, sizes, prev, pager, next, jumper" :total="study.total">
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
          </div>

          <!-- 分页-->
          <!-- <div class="block center">
            <el-pagination @size-change="(val) => handleSizeChange('study', val)"
              @current-change="(val) => handleCurrentChange('study', val)" :current-page="study.currentPage"
              :page-sizes="[10, 20, 30, 40]" :page-size="study.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="study.total">
            </el-pagination>
          </div> -->
        </el-tab-pane>

        <!-- 考试任务 -->
        <el-tab-pane stripe style="margin-left: 25px;">
          <span slot="label">
            <span class="span-box">
              <span>考试任务</span>
                <span class="btn-bell-badge" style="background-color: #409eff;border-radius:5px;">
                  <span class="num" style="padding: 0.625rem;color: white;">{{exam.count}}</span>
                </span>
            </span>
          </span>
          <div class="con">
            <el-tabs type="border-card" :stretch='true' @tab-click="exam_handleClick" v-model="exam.end" >
              <el-tab-pane v-for="(item,exam_index) in exam_type_list" :label="item.label" :name="item.name" :key="exam_index">
            <!-- 搜索框 -->
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model.trim="search"
             @keyup.enter.native="searchAllCompany('exam')"  style="width: 90%;margin: 0 5%;">
            </el-input>
            <!-- 表格 -->
            <el-table :data="exam.list" stripe style="width: 90%;margin: 0 5%;" fit>
              <el-table-column prop="name" sortable label="任务主题">
              </el-table-column>
              <el-table-column label="任务级别">
                <template slot-scope="scope">
                  <span v-if="exam.list[scope.$index].role_type==0">企业级</span>
                  <span v-if="exam.list[scope.$index].role_type==1">部门级</span>
                  <span v-if="exam.list[scope.$index].role_type==2">个人级</span>
                </template>
              </el-table-column>
              <el-table-column prop="start_time" sortable label="开始日期">
              </el-table-column>
              <el-table-column prop="end_time" sortable label="结束日期">
              </el-table-column>
              <el-table-column label="任务状态">
                <template slot-scope="scope">
                  <span
                    v-if="new Date(exam.list[scope.$index].start_time).getTime()>new Date(exam.today).getTime()">
                    <img src="../../../assets/red.jpg" class="imgs" />
                    未开启</span>
                  <span v-else>
                    <span v-if="exam.list[scope.$index].end==0">
                      <span v-if="exam.list[scope.$index].start==0">
                        <img src="../../../assets/red.jpg" class="imgs" />
                        未开始</span>
                      <span v-else>
                        <span
                          v-if="new Date(exam.today).getTime()<=new Date(exam.list[scope.$index].end_time).getTime()">
                            <img src="../../../assets/red.jpg" class="imgs" />
                            进行中</span>
                        <span v-else>
                          <img src="../../../assets/red.jpg" class="imgs"/>
                          已逾期</span>
                      </span>
                    </span>
                    <span v-else>
                      <span
                        v-if="new Date(exam.list[scope.$index].end).getTime()<=new Date(exam.list[scope.$index].end_time+' 23:59:59').getTime()">
                          <img src="../../../assets/green.jpg" class="imgs" />已完成</span>
                      <span v-else>
                        <img src="../../../assets/green.jpg" class="imgs" />
                        逾期完成</span>
                    </span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="考核状态">
                <template slot-scope="scope">
                  <span
                    v-if="new Date(exam.list[scope.$index].start_time).getTime()>new Date(exam.today).getTime()">
                    <img src="../../../assets/red.jpg" class="imgs" />未开启</span>
                  <span v-else>
                    <span v-if="exam.list[scope.$index].status==1">
                      <span v-if="exam.list[scope.$index].status_scord==1">
                        <img src="../../../assets/green.jpg" class="imgs" />通过</span>
                      <span v-else>
                        <img src="../../../assets/green.jpg" class="imgs" />未通过</span>
                    </span>
                    <span v-else>
                      <span>
                        <img src="../../../assets/red.jpg" class="imgs" />未进行</span>
                    </span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span v-if="exam.list[scope.$index].status=='1'">
                    <el-button v-if="exam.list[scope.$index].type!='2'" @click="study_train(exam.list[scope.$index].num,'watch')" size="mini">任务回看</el-button>
                    <span v-if="exam.list[scope.$index].status_scord!='1' && exam.list[scope.$index].exam_num">
                      <el-button size="mini" @click="study_train(exam.list[scope.$index].num,'train')"  v-loading.fullscreen.lock="fullscreenLoading">进行补考</el-button>
                    </span>
                    <span v-if="!exam.list[scope.$index].exam_num || exam.list[scope.$index].status_scord=='1'">
                      <el-button size="mini" @click="study_exam(exam.list[scope.$index].num)"  v-loading.fullscreen.lock="fullscreenLoading">试卷查看</el-button>
                    </span>
                  </span>
                  <span v-else>
                    <el-button size="mini" @click="study_train(exam.list[scope.$index].num,'train')">进行任务</el-button>
                  </span>
                  <span >
                    <el-button @click="study_watch(scope.row,'queren')"
                      v-if="scope.row.confirm_status=='1' && scope.row.confirm!='1' && scope.row.end!='0'"  size="mini">
                      任务确认
                    </el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页-->
              <div class="block center">
                <el-pagination @size-change="(val) => handleSizeChange('exam', val)"
                  @current-change="(val) => handleCurrentChange('exam', val)" :current-page="exam.currentPage"
                  :page-sizes="[10, 20, 30, 40]" :page-size="exam.pageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="exam.total">
                </el-pagination>
              </div>
              </el-tab-pane>
            </el-tabs>
          </div>


        </el-tab-pane>

        <!-- 线下任务 -->
        <el-tab-pane label="线下任务" stripe style="margin-left: 25px;">
          <span slot="label">
            <span class="span-box">
              <span>线下任务</span>
                <span class="btn-bell-badge" style="background-color: #409eff;border-radius:5px;">
                  <span class="num" style="padding: 0.625rem;color: white;">{{outline.total}}</span>
                </span>
            </span>
          </span>
          <div class="con">
            <!-- 搜索框 -->
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model.trim="search"
              @keyup.enter.native="searchAllCompany('outline')"  style="width: 90%;margin: 0 5%;">
            </el-input>
            <!-- 表格 -->
            <el-table :data="outline.list" stripe style="width: 90%;margin: 0 5%;" fit>
              <el-table-column prop="name" sortable label="任务主题">
              </el-table-column>
              <el-table-column label="任务级别">
                <template slot-scope="scope">
                  <span v-if="outline.list[scope.$index].role_type==0">企业级</span>
                  <span v-if="outline.list[scope.$index].role_type==1">部门级</span>
                  <span v-if="outline.list[scope.$index].role_type==2">个人级</span>
                </template>
              </el-table-column>
              <el-table-column prop="start_time" sortable label="开始日期">
              </el-table-column>
              <el-table-column prop="end_time" sortable label="结束日期">
              </el-table-column>
              <el-table-column sortable label="任务状态">
                <span>已完成</span>
              </el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button @click="study_watch(scope.row,'outline')" size="mini">查看任务</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 分页-->
          <div class="block center">
            <el-pagination @size-change="(val) => handleSizeChange('outline', val)"
              @current-change="(val) => handleCurrentChange('outline', val)" :current-page="outline.currentPage"
              :page-sizes="[10, 20, 30, 40]" :page-size="outline.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="outline.total">
            </el-pagination>
          </div>
        </el-tab-pane>

        <!-- 我的证书-->
        <el-tab-pane label="我的证书" stripe style="margin-left: 25px;">
          <span slot="label">
            <span class="span-box">
              <span>我的证书</span>
                <span class="btn-bell-badge" style="background-color: #409eff;border-radius:5px;">
                  <span class="num" style="padding: 0.625rem;color: white;">{{cert.total}}</span>
                </span>
            </span>
          </span>
          <div class="con">
            <!-- 搜索框 -->
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model.trim="search"
             @keyup.enter.native="searchAllCompany('wdzs')"  style="width: 90%;margin: 0 5%;">
            </el-input>
            <!-- 表格 -->
            <el-table :data="cert.list" stripe style="width: 90%;margin: 0 5%;" fit>
              <el-table-column prop="num" sortable label="证书序号">
              </el-table-column>
              <el-table-column sortable label="证书">
                <img src="../../../assets/certficate.png" alt="" class="certimg">
              </el-table-column>
              <el-table-column prop="name" sortable label="证书名称">
              </el-table-column>
              <el-table-column prop="time" sortable label="获取日期">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="cert_watch(cert.list[scope.$index].num)" size="mini">查看证书</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页-->
          <div class="block center">
            <el-pagination @size-change="(val) => handleSizeChange('cert', val)"
              @current-change="(val) => handleCurrentChange('cert', val)" :current-page="cert.currentPage"
              :page-sizes="[10, 20, 30, 40]" :page-size="cert.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="cert.total">
            </el-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="问卷调查" stripe style="margin-left: 25px;">
          <span slot="label">
            <span class="span-box">
              <span>问卷调查</span>
                <span class="btn-bell-badge" style="background-color: #409eff;border-radius:5px;">
                  <span class="num" style="padding: 0.625rem;color: white;">{{questionnaire.total}}</span>
                </span>
            </span>
          </span>
          <div class="con">
            <!-- 搜索框 -->
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="questionnaire.input"
             @keyup.enter.native="quest_sear()"  style="width: 90%;margin: 0 5%;">
            </el-input>
            <!-- 表格 -->
            <el-table :data="questionnaire.list"
            stripe style="width: 90%;margin: 0 5%;" fit>
              <el-table-column prop="name" sortable label="问卷主题">
              </el-table-column>
              <el-table-column prop="i_start" width="120" sortable label="开始日期">
              </el-table-column>
              <el-table-column prop="i_end" width="120" sortable label="结束日期">
              </el-table-column>
              <el-table-column  label="操作" width="120">
                <template slot-scope="scope">
                  <el-button    size="mini" disabled v-if="new Date(scope.row.i_start).getTime()>new Date(study.today).getTime()">未开启</el-button>
                  <el-row v-else>
                    <el-button  @click="quest_watch(scope.row,'write')" size="mini" v-if="scope.row.end=='0'">去填写</el-button>
                    <el-button  size="mini" @click="quest_watch(scope.row,'see')" v-else>查看</el-button>
                  </el-row>

                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页-->
          <div class="block center">
            <el-pagination @size-change="quest_handle"
              @current-change="quest_Current" :current-page="questionnaire.currentPage"
              :page-sizes="[10, 20, 30, 40]" :page-size="questionnaire.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="questionnaire.total">
            </el-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="定制" stripe style="margin-left: 25px;">
          <span slot="label">
            <span class="span-box">
              <span>测评任务</span>
                <span class="btn-bell-badge" style="background-color: #409eff;border-radius:5px;">
                  <span class="num" style="padding: 0.625rem;color: white;">{{evaluation.exam.total}}</span>
                </span>
            </span>
          </span>
          <div class="con">
            <!-- 搜索框 -->
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model.trim="evaluation.search"
               @keyup.enter.native="searchAllCompany_eval()('exam')"  style="width: 90%;margin: 0 5%;">
              </el-input>
              <!-- 表格 -->
              <el-table :data="evaluation.exam.list" stripe style="width: 90%;margin: 0 5%;" fit>
                <el-table-column prop="name" sortable label="试卷名称">
                </el-table-column>
                <el-table-column label="发布人" prop="push">
                </el-table-column>
                <el-table-column prop="c_time" sortable label="发布时间"width="250" >
                </el-table-column>
                <el-table-column prop="e_s_time" sortable label="开始日期">
                </el-table-column>
                <el-table-column prop="e_e_time" sortable label="结束日期">
                </el-table-column>
                <el-table-column label="考试状态" >
                  <template slot-scope="scope">
                    <span
                      v-if="new Date(evaluation.exam.list[scope.$index].e_s_time).getTime()>new Date(evaluation.exam.today).getTime()">
                      <el-tooltip class="item" effect="dark" content="考试时间还没到,请耐心等待" placement="top-start">
                            <span>
                              <img src="../../../assets/red.jpg" class="imgs" />
                              未开启
                            </span>
                      </el-tooltip>
                    </span>
                    <span v-else-if="new Date(evaluation.exam.list[scope.$index].e_e_time).getTime()>new Date(evaluation.exam.today).getTime()">
                      <el-tooltip class="item" effect="dark" content="考试进行中,快来参加考试吧" placement="top-start">
                            <span>
                              <img src="../../../assets/green.jpg" class="imgs" />
                              进行中
                            </span>
                      </el-tooltip>
                    </span>
                    <span v-else>
                      <el-tooltip class="item" effect="dark" content="考试时间已结束" placement="top-start">
                      <span>
                        <img src="../../../assets/red.jpg" class="imgs" />
                        已结束
                      </span>
                      </el-tooltip>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="考核状态">
                  <template slot-scope="scope">
                    <span
                      v-if="new Date(evaluation.exam.list[scope.$index].e_s_time).getTime()>new Date(evaluation.exam.today).getTime()">

                      <el-tooltip class="item" effect="dark" content="考试还未开始" placement="top-start">
                            <span>
                               <img src="../../../assets/red.jpg" class="imgs" />未开启
                            </span>
                      </el-tooltip>
                      </span>
                    <span v-else>
                      <span v-if="evaluation.exam.list[scope.$index].c_e_time==0">
                         <el-tooltip class="item" effect="dark" content="您还未参加考试" placement="top-start">
                               <span>
                                  <img src="../../../assets/red.jpg" class="imgs" />未进行
                               </span>
                         </el-tooltip>
                      </span>
                      <span v-else>
                        <span v-if="evaluation.exam.list[scope.$index].status=='1'">
                          <el-tooltip class="item" effect="dark" content="您开始未通过哦,还要继续努力" placement="top-start">
                                <span>
                                   <img src="../../../assets/red.jpg" class="imgs" />未通过
                                </span>
                          </el-tooltip>
                          </span>
                          <span v-if="evaluation.exam.list[scope.$index].status=='2'">
                            <el-tooltip class="item" effect="dark" content="恭喜您通过考试" placement="top-start">
                                  <span>
                                     <img src="../../../assets/green.jpg" class="imgs" />通过
                                  </span>
                            </el-tooltip>
                            </span>
                        </span>

                        </span>
                      </span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span v-if="new Date(evaluation.exam.list[scope.$index].e_e_time).getTime()<new Date(evaluation.exam.today).getTime()">
                      <span v-if="evaluation.exam.list[scope.$index].overdue!='0'">
                        <span v-if="evaluation.exam.list[scope.$index].exam_status">
                          <el-button size="mini" @click="study_train_eval()(evaluation.exam.list[scope.$index].num,'train')"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">进行补考</el-button>
                        </span>
                        <span v-else>
                          <el-button size="mini" @click="study_exam_eval(exam.list[scope.$index].num)"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">试卷查看</el-button>
                        </span>
                      </span>
                      <span v-else style="color: red;">
                        <!-- <el-tooltip class="item" effect="dark" content="考试通道已关闭,不可逾期考试哦" placement="top-start">
                              <span>
                                 考试已结束
                              </span>
                        </el-tooltip> -->
                        <el-button size="mini" @click="study_exam_eval(evaluation.exam.list[scope.$index].num)"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">试卷查看</el-button>
                      </span>
                    </span>
                    <span v-else-if="new Date(evaluation.exam.list[scope.$index].e_s_time).getTime()>new Date(evaluation.exam.today).getTime()">
                      考试未开始
                    </span>
                    <span v-else>
                      <span v-if="evaluation.exam.list[scope.$index].c_e_time!='0'">
                        <span v-if="evaluation.exam.list[scope.$index].exam_status">
                          <el-button size="mini" @click="study_train_eval(evaluation.exam.list[scope.$index].num,'train')"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">进行补考</el-button>
                        </span>
                        <span v-else>
                          <el-button size="mini" @click="study_exam_eval(evaluation.exam.list[scope.$index].num)"  v-loading.fullscreen.lock="evaluation.fullscreenLoading">试卷查看</el-button>
                        </span>
                      </span>
                      <span v-else>
                        <el-button size="mini" @click="study_train_eval(evaluation.exam.list[scope.$index].num,'train')">进行考试</el-button>
                      </span>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页-->
            <div class="block center">
              <el-pagination @size-change="(val) => handleSizeChange_eval('exam', val)"
                @current-change="(val) => handleCurrentChange_eval('exam', val)" :current-page="evaluation.exam.currentPage"
                :page-sizes="[10, 20, 30, 40]" :page-size="evaluation.exam.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="evaluation.exam.total">
              </el-pagination>
            </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="查看证书" :visible.sync="show.show" width="950px">
        <el-button class="restore-btn"   type="primary" @click="saveImage('html2canvas', '证书')" >下载</el-button>
        <div class="cert_bk" ref="html2canvas" style="padding: 25px;margin: 25px;width: 800px;">
          <p style="width: 100%;text-align: center;font-size: 45px;font-weight: 700;margin:70px 0 0 0;">培 训 证 书</p>
          <span style="width: 300px;float: right;font-size: 17px;margin: 15px 5px;">
              证书编号：{{show.info.num}}
            </span>
          <div style="height: 125px;padding: 30px 65px 50px 65px;width:cala( 100% - 130px);">
            <h2 style="padding-left: 50px;font-size: 22px;">{{show.info.rale_name}}</h2>
            <b style="margin: 75px;font-size: 17px;width: 100%;">于{{show.info.t_start}}至{{show.info.t_end}}期间，参加 {{show.info.name}}
                培训，成绩合格，特发此证！</b>
          </div>
          <div>
              <div style="float: right;width: 300px;padding-right: 80px;text-align: center;font-weight: 600;font-size: 16px;">
                {{show.info.company}}<br>
                {{show.info.end}}
              </div>
          </div>
        </div>
      </el-dialog>
      <!-- 任务确认弹框 -->
      <el-dialog title="任务确认" :visible.sync="queren_show.show">
         <p style="display: flex; justify-content: center; margin-bottom: 3rem;">{{queren_show.lists.name}}</p>
         <table>
         <tr>
         <td>任务类型：{{queren_show.lists.t_id}}</td>
         <td>任务级别：<span v-if="queren_show.lists.role==0">企业级</span>
             <span v-if="queren_show.lists.role==1">部门级</span>
             <span v-if="queren_show.lists.role==2">个人级</span>
          </td>
         <td>任务部门：{{queren_show.lists.section}}</td>
         <td></td>
         </tr>
         <tr>
         <td colspan="2">任务开始时间：{{queren_show.lists.t_start}}</td>
         <td colspan="2">任务结束时间：{{queren_show.lists.t_end}}</td>
         </tr>
         <tr v-if="queren_show.lists.task_type=='file'">
         <td colspan="4">文档列表：
         <span v-for="item in queren_show.lists.content.list" style="margin-left: 1rem;">
         {{item.name}}({{item.status}})</span>
         </td>
         </tr>
         <tr v-if="queren_show.lists.task_type=='video'">
         <td colspan="4">视频列表：<span v-for="item in queren_show.lists.content.list" style="margin-left: 1rem;">
           {{item.name}}({{item.status}})</span></td>
         </tr>
         <tr v-if="queren_show.lists.subject=='0'">
         <td>是否考试：否</td>
         </tr>
        <tr v-else>
         <td>是否考试：是</td>
         <td>考试题库：<span v-if="queren_show.lists.subject_type!='0'">{{queren_show.lists.subject_type}}</span>
            <span v-else>跟随资源抽卷</span></td>
         <td>题目数：{{queren_show.lists.subject}}</td>
         <td>及格分：{{queren_show.lists.subject_score}}</td>
         </tr>
         <tr>
         <td colspan="2">员工开始时间：{{queren_show.lists.start}}</td>
         <td colspan="2">员工结束时间：{{queren_show.lists.end}}</td>
         </tr>
         <tr>
         <td colspan="2" v-if="queren_show.lists.subject!='0'">
          考试状态：
          <span v-if="queren_show.lists.status=='1'">
            <span v-if="queren_show.lists.status_scord=='1'">通过</span>
            <span v-else>未通过</span>
          </span>
          <span v-else>未完成</span>
         </td>
         <td colspan="2" v-if="queren_show.lists.confirm != '0'" >结果确认状态：
           <span v-if="queren_show.lists.confirm_status =='0'">未确认</span>
           <span v-if="queren_show.lists.confirm_status =='-1'">存在疑惑</span>
           <span v-if="queren_show.lists.confirm_status =='1'">已确认</span>
          </td>
         </tr>
         <tr v-if="queren_show.lists.idcard != '0'">
           <td>
             电子签名：
             <span v-if="queren_show.lists.idcard_status =='0'">未签名</span>
             <span v-if="queren_show.lists.idcard_status =='1'">已签名</span>
           </td>
         </tr>
         </table>
         <div slot="footer" class="dialog-footer">
           <el-button type="primary" @click="confirm_submit(queren_show.lists.num,'1')">确 认</el-button>
            <el-button  @click="confirm_submit(queren_show.lists.num,'-1')">存在疑问</el-button>
         </div>
      </el-dialog>
      <!--电子签名-->
      <el-dialog title="电子签名" :visible.sync="autograph.show" @close="closeDialog()">
        请输入您的密码: <el-input show-password v-model="autograph.input" style="margin: 1rem 0 1rem 0 ;"></el-input>
        <span >您触发的时间的: {{autograph.time}}</span>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="autograph_click('ok')">确 认</el-button>
           <el-button  @click="autograph_click('on')">取消</el-button>
        </div>
      </el-dialog>
      <!--任务查看-->
      <el-dialog title="任务查看" :visible.sync="outline.show">
        <p style="display: flex; justify-content: center; margin-bottom: 3rem;">{{outline.viewtask_list.name}}</p>
        <table>
          <tr> <td>任务分类：{{outline.viewtask_list.type}}</td>
          <td> 任务级别：<span v-if="outline.viewtask_list.role==0">企业级</span>
          <span v-if="outline.viewtask_list.role==1">部门级</span>
          <span v-if="outline.viewtask_list.role==2">个人级</span>
          </td>
          <td> 任务类型：	{{outline.viewtask_list.t_id}}</td>
          </tr>
          <tr>
            <td>培训部门：{{outline.viewtask_list.section}}</td>
            <td> 创建时间：{{outline.viewtask_list.c_time}}	</td>
          </tr>
          <tr>
          <td colspan="3"> 培训内容：{{outline.viewtask_list.content}}</td>
          </tr>
          <tr>
            <td colspan="3"> 培训说明：	{{outline.viewtask_list.info}}</td>
          </tr>
          <tr> <td>开始时间：{{outline.viewtask_list.start_time}} </td>
          <td> 	结束时间：{{outline.viewtask_list.end_time}}</td>

          </tr>
        </table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="outline.show=false">确  定</el-button>
        </div>
      </el-dialog>
      <!--试卷查看-->
      <el-dialog title="试卷查看" :visible.sync="exam.exam_show">
        <el-table
            :data="exam.details_list"
            stripe
            style="width: 100%">
            <el-table-column prop="time" label="考试时间">
            </el-table-column>
            <el-table-column label="分数" prop="score">
            </el-table-column>
            <el-table-column
                  fixed="right"
                  label="操作"
                  >
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="exam_see(scope.row.num)">查看</el-button>
                  </template>
                </el-table-column>
          </el-table>
      </el-dialog>
      <el-dialog title="培训需知" :visible.sync="anhui_show" style="25em">
        <span style="color: red;font-size: 2em;height: 20em;">
          根据省局要求，请先完成《培训质量评估调查》，再进行此次培训考核。<br/>
          点此进行《培训质量评估调查》：<a href="https://www.wjx.cn/vj/e0wQ0mI.aspx" target="_blank" style=" text-decoration:none; ">《培训质量评估调查》</a>
        </span>
      </el-dialog>
      <!--试卷查看-->
      <el-dialog title="试卷查看" :visible.sync="evaluation.exam.exam_show">
        <el-table
            :data="evaluation.exam.details_list"
            stripe
            style="width: 100%">
            <el-table-column prop="c_time" label="考试时间">
            </el-table-column>
            <el-table-column label="分数" prop="score">
            </el-table-column>
            <el-table-column
                  fixed="right"
                  label="操作"
                  >
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="exam_see_eval(scope.row.num)">查看</el-button>
                  </template>
                </el-table-column>
          </el-table>
      </el-dialog>
      <!--温馨提示-->
      <el-dialog  :visible.sync="evaluation.type_show" width='30%'>
        <span >
          <span style="color: red;font-size: 1.25rem;"> 您想了解：</span></br></br>
          对法规与指南的了解程度吗？</br></br>
          招聘过程中，待入职员工的真实专业水平吗？</br></br>
          本部门员工的专业水平吗？</br></br>
          员工专业水平的不足之处吗？</br></br>
          方便、简单、易操作给员工进行自由组卷测试吗？</br></br>
          自己的专业水平吗？</br></br>
          <span style="color: blue;font-size: 1.25rem;">测评模块</span>满足您的各种测试需求</br></br>
          <span style="color: red;"> 如有需要请联系王老师(13260265598 同微信)</span></br></br>
        </span>

      </el-dialog>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../components/index/public/NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import html2canvas from 'html2canvas';
  export default {
    data() {
      return {
        type_list:[{
            label:'未完成',
            name:'0'
          },
          {
            label:'已完成',
            name:'1'
          },
        ],
        exam_type_list:[{
            label:'未完成',
            name:'0'
          },
          {
            label:'已完成(包含可补考任务)',
            name:'1'
          },
        ],
        // info:this.$store.state.info,
        evaluation:{
          type_show:false,
          dstimers:null,
          autograph:{
            time:'',
            show:false,
            input:'',
            num:''
          },
        fullscreenLoading:false,
        search: '',
        exam: {
          list: [],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize:10,
          today: '',
          exam_show:false,//考试弹框
          details_list:[],
        },
        },
        anhui_show:false,
        dstimers:null,
        autograph:{
          time:'',
          show:false,
          input:'',
          num:''
        },
        fullscreenLoading:false,
        search: '',
        //问卷调查
        questionnaire: {
          list: [],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          today: '',
          input:'',
          end:0
        },
        //任务确认弹框
        queren_show:{
          show:false,
          lists:{
            content: {
            	list: [],
            }
          }
        },

        study: {
          list: [],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          today: '',
          end:0,
          count:'',
        },
        exam: {
          list: [],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          today: '',
          exam_show:false,//考试弹框
          details_list:[],
          end:0,
          count:'',
        },
        outline: {
          list: [],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          today: '',
          show:false,
          viewtask_list:{},
          end:0,
          count:'',
        },
        cert: {
          list: [],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          today: '',
          end:0,
          count:'',
        },
        show: {
          info: '',
          show: false
        }
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted() {
      this.get_task('study')
      this.get_task('exam')
      this.get_task('outline')
      this.get_cert()
      this.get_task_eval()
      this.get_questionnaire()
      this.now_day_eval()
      if(this.$store.state.info.company.name=='北京睿知而行科技有限公司-药知企业教育平台'){
        this.anhui_show=true
      }
    },
    methods: {
      study_handleClick(tab, event) {
        // console.log(tab, event);
        this.study.list=[]
        this.study.list=[]
        this.study.currentPage=1
        this.study.pageSize=10
        this.search=''
        this.get_task('study')
      },
      exam_handleClick(tab, event) {
        // console.log(tab, event);
        this.exam.list=[]
        this.exam.list=[]
        this.exam.currentPage=1
        this.exam.pageSize=10
        this.search=''
        this.get_task('exam')
      },
      now_day_eval(){
        var nowDate = new Date();
        var date = {
          year: nowDate.getFullYear(),
          month: nowDate.getMonth() + 1,
          day: nowDate.getDate(),
        }
        var dayDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day)
        this.evaluation.exam.today=dayDate
      },
      get_task_eval(){
        let _this=this
        _this.axios.get('/v2/user_evaluate/exam_list', {
          params: {
            page: _this.evaluation.exam.currentPage,
            limit:Number(_this.evaluation.exam.pageSize),
            'keyword':_this.evaluation.search,
          }
        }).then(function(res) {
          if (res.status == '200') {
            if (res.data.code == '1') {
             _this.evaluation.exam.list=res.data.data.list
             _this.evaluation.exam.currentPage=res.data.data.currentPage
             _this.evaluation.exam.total=res.data.data.total
             _this.evaluation.exam.pageSize=Number(res.data.data.pageSize)
            } else {
              _this.evaluation.type_show=true
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      //考试详情
      exam_see_eval(num){
        window.open('evalsubjeCtresult?num='+num,'_blank');
      },
      //搜索框回车事件
       searchAllCompany_eval(type){
         let _this=this;
           _this.get_task_eval()
         // _this.search=''
       },
      /* 分页*/
      handleSizeChange_eval(type, val) {
        let _this = this
        _this.evaluation.exam.pageSize = val
        _this.evaluation.exam.currentPage = 1
          _this.get_task_eval()
      },
      handleCurrentChange_eval(type, val) {
        let _this = this
        _this.evaluation.exam.currentPage = val
          _this.get_task()
      },
      study_exam_eval(val){
        let _this=this
        _this.axios.get('/v2/user_evaluate/get_exam_list',{params:{'num':val}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.evaluation.exam.details_list=res.data.data
              _this.evaluation.exam.exam_show=true
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      /* study*/
      study_train_eval(val,type){
        let _this=this
        _this.axios.get('/v2/user_evaluate/get_subject',{
          params: {num: val },}
        ).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              window.open('evalsubject?num='+val,'_blank');
             }else{
               _this.$message.error(res.data.msg);
             }
          }
         })

      },
      get_questionnaire(){
        let _this=this
        _this.axios.get('/v2/user_inves/inves_list', {
            params: {
              page: _this.questionnaire.currentPage,
              limit: _this.questionnaire.pageSize,
              keyword:_this.questionnaire.input
            }
          }).then(function(res) {
            if (res.status == '200') {
              if (res.data.code == '1') {
                _this.questionnaire.list=res.data.data.data
                _this.questionnaire.currentPage=res.data.data.current_page
                _this.questionnaire.total=res.data.data.total
              } else {
                _this.$message.error(res.data.data.msg)
              }
            } else {
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });
        },
      quest_handle(val){
        //每页显示多少条
        let _this=this
        _this.questionnaire.pageSize=val
        _this.get_questionnaire()
      },
      quest_Current(){
        //显示第几页
        let _this=this
        _this.questionnaire.currentPage=val
        _this.get_questionnaire()
      },
      quest_sear(){
        let _this=this
        _this.get_questionnaire()
      },
      quest_watch(item,type){
        this.$router.push({path:'/TaskQuestionnaire',query:{num:item.num,type:type}})
      },
            //考试详情
      exam_see(num){
        // this.$router.push({path:'/TasksubjeCtresult',query:{num:num}})
        let routeData = this.$router.resolve({
               path: '/TasksubjeCtresult',
               query: {num:num}
             });
             window.open(routeData.href, "");
      },
      up_task(){
        this.get_task('study')
        this.get_task('exam')
        this.get_task('outline')
      },
      closeDialog(){
        this.autograph_click('')
      },
      autograph_click(type){
        let _this=this
        if(type=='ok'){
          if(_this.autograph.input.length==0){
            _this.$message.error('请输入密码')
            return false
          }
          _this.axios.post('/v2/user_task/task_idcard', {data:{'num':_this.autograph.num,'input':_this.autograph.input}}).then(function(res) {
            if (res.status == '200') {
              if (res.data.code == '1') {
                _this.$message.success(res.data.msg)
                _this.autograph.show=false
                _this.clear_dstimers()
                _this.up_task()
              } else {
                _this.$message.error(res.data.msg)
              }
            } else {
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });
        }else{
            _this.autograph.show=false
            _this.clear_dstimers()
        }
      },
      //任务确认弹框提交
      confirm_submit(val,type){
        let _this=this;
        _this.axios.post('/v2/user_task/task_confirm',{data:{'num':val,'status':type}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
               _this.$message.success(res.data.msg)
              if(type!='1'){
                _this.$message.success('请与任务发布人联系！！！')
              }else{
                _this.up_task()
              }
              _this.queren_show.show=false;
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      //搜索框回车事件
       searchAllCompany(type){
         let _this=this;
         if(type=="wdzs"){
           _this.get_cert()
         }else {
           _this.get_task(type)
         }
         // _this.search=''
       },
      get_task(type) {
        let _this = this
        _this.axios.get('/v2/user_task/get_task', {
          params: {
            type: type,
            page: _this[type].currentPage,
            limit: _this[type].pageSize,
            'keyword':_this.search,
            end:_this[type].end
          }
        }).then(function(res) {
          if (res.status == '200') {
            if (res.data.code == '1') {
              _this[type].currentPage = res.data.data.list.current_page
              _this[type].total = res.data.data.list.total
              _this[type].list = res.data.data.list.data
              _this[type].today = res.data.data.today
              _this[type].count = res.data.data.count
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_cert() {
        let _this = this
        _this.axios.get('/v2/user/get_cert', {
          params: {
            page: _this.cert.currentPage,
            limit: _this.cert.pageSize,'keyword':_this.search
          }
        }).then(function(res) {
          if (res.status == '200') {
            if (res.data.code == '1') {
              _this.cert.currentPage = res.data.data.list.current_page
              _this.cert.total = res.data.data.list.total
              _this.cert.list = res.data.data.list.data
              _this.cert.today = res.data.data.today
            } else {
              _this.$message.error(res.msg)
            }
          } else {
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      /* 分页*/
      cert_watch(num) {
        let _this = this
        _this.axios.get('/v2/user/get_cert_info', {
          params: {
            num: num
          }
        }).then(function(res) {
          if (res.status == '200') {
            if (res.data.code == '1') {
              _this.show.info = res.data.data
              _this.show.show = true
            } else {
              _this.$message.error(res.msg)
            }
          } else {
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleSizeChange(type, val) {
        let _this = this
        _this[type].pageSize = val
        _this[type].currentPage = 1
        if (type == 'cert') {
          _this.get_cert()
        } else {
          _this.get_task(type)
        }
      },
      handleCurrentChange(type, val) {
        let _this = this
        _this[type].currentPage = val
        if (type == 'cert') {
          _this.get_cert()
        } else {
          _this.get_task(type)
        }
      },
      study_exam(val){
        let _this=this
        _this.axios.get('/v2/user_task/get_user_task_exam',{params:{'num':val}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.exam.details_list=res.data.data
              _this.exam.exam_show=true
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      /* study*/
      study_train(val,type){
        let _this=this
        _this.axios.post('/v2/user_task/check_task_type',{data:{'num':val,type:type}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$router.push({path:'/task'+res.data.data,query:{num:val}})
               // let routeData = _this.$router.resolve({
               //    path: '/task'+res.data.data,
               //    query: {num:val}
               //  });
               //  window.open( routeData.href,'_blank');
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      count_down(){
        if(!this.dstimers){
          this.dstimers= setInterval(() => {
          let yy = new Date().getFullYear();
          　　let mm = new Date().getMonth()+1;
          　　let dd = new Date().getDate();
          　　let hh = new Date().getHours();
          　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
          　　let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
          　　this.autograph.time = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
            return;
          }, 1000);
        }

      },
      clear_dstimers(){
        clearInterval( this.dstimers)
        this.dstimers=null
        this.autograph.time=''
        this.autograph.input=''
      },
      study_watch(val,type){
        let _this=this;
        if(type=='qianming'){
          _this.autograph.num=val.num
          _this.count_down()
          _this.autograph.show=true
        }else if(type=='queren'){
          _this.get_task_info(val,'online')
        }else if(type=='outline'){
          _this.get_task_info(val,'outline')
        }
      },
      get_task_info(val,type){
        let _this=this
        _this.axios.get('/v2/user_task/get_user_task_info',{params:{'num':val.num,'type':type}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              if(type=='online'){
                  _this.queren_show.lists=res.data.data
                  _this.queren_show.show=true
              }else{
                _this.outline.viewtask_list=res.data.data
                _this.outline.show=true
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      //图片格式转换方法
      dataURLToBlob(dataurl) {
        let arr = dataurl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
          type: mime
        });
      },
      //点击方法
      saveImage(divText, imgText) {
        let that = this;
        let canvasID = that.$refs[divText];
        let a = document.createElement('a');
        setTimeout(() => {
          window.pageYOffset = 0;
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
          html2canvas(canvasID).then(canvas => {
            let dom = document.body.appendChild(canvas);
            dom.style.display = 'none';
            a.style.display = 'none';
            document.body.removeChild(dom);
            let blob = that.dataURLToBlob(dom.toDataURL('image/png'));
            a.setAttribute('href', URL.createObjectURL(blob));
            //这块是保存图片操作  可以设置保存的图片的信息
            a.setAttribute('download', imgText + '.png');
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(blob);
            document.body.removeChild(a);
          });
        }, 500);
      },
    }
  }
</script>

<style scoped>
  table
  {
  border-collapse :collapse ;
  width: 100%;
  }
  th,td
  {
  width:23%;
  height:40px;
  font-size:15px;
  }
 >>>.el-dialog__body{
    padding: 0 2rem 2rem 2rem;
  }
  .imgs{
    width: 10%;
    height: 10%;
  }
  .cert_bk {
    width: 100%;
    height: 30rem;
    background-image: url(../../../assets/cert_bk.jpg);
    background-size: 100% 100%;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  h1 {
    margin: 20px;
  }

.el-tabs {
    width: 90%;
    margin: 0 5%;
  }

.el-form-item__label {
    padding-right: 30px;
  }

  .el-form-item .el-avatar {
    width: 100px;
    height: 100px;
  }

  .el-button {

    margin: 2px 0;
  }

  .con {
    /* 分页占位*/
    min-height: calc(100vh - 504px);
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }

  .certimg {
    width: 100%;
  }

  /* 证书 */
  .restore-btn{
    position: absolute;
    bottom: 0.2rem;
    right: 10px;
  }
  /**路由 */
  .linkz{
    text-decoration:none;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/Task/Tasklist.vue